/* MachinePro - comparateur (localStorage + barre flottante + garde-fou famille) */
(function () {
  var KEY='mp_compare', TKEY='mp_compare_types', MAX=3;
  function get(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function types(){ try{ return JSON.parse(localStorage.getItem(TKEY)||'{}'); }catch(e){ return {}; } }
  function save(arr,tp){ localStorage.setItem(KEY, JSON.stringify(arr.slice(0,MAX))); localStorage.setItem(TKEY, JSON.stringify(tp)); render(); }
  function currentType(){ var a=get(),tp=types(); return a.length?(tp[a[0]]||null):null; }
  function add(h,t){ var a=get(),tp=types(); if(a.indexOf(h)!==-1||a.length>=MAX) return; a.push(h); tp[h]=t||''; save(a,tp); }
  function remove(h){ var tp=types(); delete tp[h]; save(get().filter(function(x){return x!==h;}),tp); }
  function clear(){ save([],{}); }
  function toast(msg){ var el=document.getElementById('mp-compare-toast'); if(!el){ alert(msg); return; } el.textContent=msg; el.classList.add('is-show'); clearTimeout(el._t); el._t=setTimeout(function(){ el.classList.remove('is-show'); },4500); }
  function syncChecks(){
    var sel=get(), ct=currentType(), full=sel.length>=MAX;
    document.querySelectorAll('input[data-compare-handle]').forEach(function(cb){
      var h=cb.getAttribute('data-compare-handle'), t=cb.getAttribute('data-compare-type')||'';
      var isSel = sel.indexOf(h)!==-1;
      cb.checked = isSel;
      var incompatible = !isSel && ct!==null && t!==ct;
      var dis = incompatible || (!isSel && full);
      cb.disabled = dis;
      var lbl=cb.closest('.mp-compare-check');
      if(lbl){
        lbl.classList.toggle('is-disabled', dis);
        lbl.classList.toggle('is-incompatible', incompatible);
        lbl.title = incompatible ? 'Famille differente : non comparable avec ta selection' : (dis ? 'Maximum 3 machines' : '');
      }
    });
  }
  function render(){
    syncChecks();
    var sel=get(), bar=document.getElementById('mp-compare-bar'); if(!bar) return;
    var count=bar.querySelector('[data-compare-count]'), btn=bar.querySelector('[data-compare-go]');
    if(count) count.textContent=sel.length;
    if(sel.length>=2){ bar.classList.add('is-visible'); if(btn){ btn.removeAttribute('aria-disabled'); btn.href='/pages/comparateur?ids='+sel.join(','); } }
    else if(sel.length===1){ bar.classList.add('is-visible'); if(btn){ btn.setAttribute('aria-disabled','true'); btn.removeAttribute('href'); } }
    else bar.classList.remove('is-visible');
  }
  document.addEventListener('change', function(e){
    var cb=e.target; if(!cb.matches||!cb.matches('input[data-compare-handle]')) return;
    var h=cb.getAttribute('data-compare-handle'), t=cb.getAttribute('data-compare-type')||'';
    if(cb.checked){
      var ct=currentType();
      if(ct!==null && t!==ct){ cb.checked=false; toast('Cette machine ne peut pas être comparée avec ta sélection : ce sont des familles différentes. Compare des machines du même type (ex. compresseur avec compresseur).'); return; }
      if(get().length>=MAX){ cb.checked=false; toast('Tu peux comparer 3 machines au maximum. Décoche-en une pour en ajouter une autre.'); return; }
      add(h,t);
    } else remove(h);
  });
  document.addEventListener('click', function(e){
    var c=e.target.closest&&e.target.closest('[data-compare-clear]'); if(c){ e.preventDefault(); clear(); }
    var g=e.target.closest&&e.target.closest('[data-compare-go]');
    if(g && g.getAttribute('aria-disabled')==='true'){ e.preventDefault(); toast('Sélectionne au moins 2 machines de la même famille pour les comparer.'); }
  });
  if(document.readyState!=='loading') render(); else document.addEventListener('DOMContentLoaded', render);
  window.MPCompare={get:get,clear:clear};
})();
